function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null);

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 300h300V0H0z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 400)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M68 160l6 29h-2l-10-13-1-1H51l-1 1-5 13h-2l-5-29-2-1H21l-1 1 14 68 1 1h16l9-29h2l20 29h16l1-1-13-68-2-1H69l-1 1M100 160l13 68 1 1h45l1-1-2-13-2-1h-28l-1-1-2-10 1-1h24l1-1-3-13-1-1h-24l-1-1-2-10 1-1h28l1-2-3-13-1-1h-45l-1 1M159 160l13 68 2 1h45l1-1-3-13-1-1h-28l-1-1-2-10 1-1h23l1-1-2-13-2-1h-23l-2-1-2-10 1-1h28l1-2-2-13-1-1h-46l-1 1M259 213l-10-53-1-1h-15l-1 1 10 53-1 1h-15l-1 1 3 13 1 1h50l1-1-3-13-1-1h-15l-2-1M83 124c-1 2-3 4-6 4s-6-2-8-4-3-4-6-17c-2-12-1-15 0-17 1-1 3-3 6-3s6 2 7 3c2 2 4 5 6 17 3 13 2 15 1 17m4-44c-6-5-12-8-21-8s-14 3-18 8c-6 7-4 17-2 27 2 11 4 21 13 28 6 5 12 8 21 8 8 0 14-3 18-8 6-7 4-17 2-28-3-10-4-20-13-27M144 73l-14 31h-2l-6-31-1-1h-15l-1 1 13 68 1 1h14l14-32c1-1 2 0 2 1l6 30 2 1h15l1-1-14-68-1-1h-13l-1 1M173 73l14 68 1 1h45l1-1-2-13-2-1h-28l-1-1-2-10 1-1h24v-1l-2-13-1-1h-24l-1-1-2-10v-1h29l1-1-3-14-1-1h-46l-1 1",
  fill: "#ff5000"
}));

function SvgMeetone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetone);
export default __webpack_public_path__ + "static/media/meetone.f606cf94.svg";
export { ForwardRef as ReactComponent };